<template>
    <div class="bg-white">
        <!-- Navigation Links (optional, for testing) -->
        <!--
        <nav class="p-4 bg-gray-200">
            <router-link to="/" class="mr-4">Home</router-link>
            <router-link to="/about">About</router-link>
        </nav>
        -->

        <!-- Router View for Displaying Routed Components -->
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
};
</script>

<style scoped>
/* Add your styles here if needed */
</style>
